(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lune-inventory"] && !Shopify.designMode) return;
  try {
    (function () {
    function refresh() {
      document.querySelectorAll('[data-lune-inv]').forEach(function (el) {
        var scope = el.closest('.shopify-section') || document;
        var cup = null;
        var checked = scope.querySelectorAll('input[type="radio"]:checked');
        for (var i = 0; i < checked.length; i++) {
          var v = checked[i].value;
          if (v === 'A' || v === 'B' || v === 'C' || v === 'D') { cup = v; break; }
        }
        if (!cup) {
          var sels = scope.querySelectorAll('select');
          for (var j = 0; j < sels.length; j++) {
            var sv = sels[j].value;
            if (sv === 'A' || sv === 'B' || sv === 'C' || sv === 'D') { cup = sv; break; }
          }
        }
        if (!cup) return;
        var low = cup === 'B' || cup === 'C';
        el.classList.remove('lune-inv--in', 'lune-inv--low');
        el.classList.add(low ? 'lune-inv--low' : 'lune-inv--in');
        var lbl = el.querySelector('.lune-inv__label');
        if (lbl) lbl.textContent = low ? (el.dataset.lLow || 'Low stock') : (el.dataset.lIn || 'In stock');
      });
    }
    function deferred() {
      refresh();
      setTimeout(refresh, 50);
      setTimeout(refresh, 250);
      setTimeout(refresh, 800);
    }
    if (!window.__luneInvHooked) {
      window.__luneInvHooked = true;
      document.addEventListener('change', deferred, true);
      document.addEventListener('click', deferred, true);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', refresh);
      } else {
        refresh();
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
